import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Thumbnail.css';

const Thumbnail = ({ tokenID, tokenName, traits, rarityRank, thumbnailSize, imageUrl }) => {
  const isLarge = thumbnailSize === 'large';
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className="thumbnail-card" style={{ width: isLarge ? '280px' : '135px' }}>
      <div className="image-container">
        {!imageLoaded && <div className="image-placeholder" />}
        <img
          src={imageUrl}
          alt="Thumbnail"
          onLoad={handleImageLoad}
          style={{ display: imageLoaded ? 'block' : 'none' }}
        />
      </div>
      <div className="title">#{tokenID}</div>
      <div className="info" style={{ fontSize: isLarge ? "20px" : "14px"}}>ROAR Society</div>
      <div className={`traits ${isLarge ? 'large' : 'small'}`}>
        {traits.map((trait, index) => (
          <div key={index} className="trait">
            <div className="trait-title">
              {trait.trait_type.toUpperCase()}
            </div>
            <div className="trait-value" style={{ marginLeft: isLarge ? "8px" : "0px"}}>
              {trait.value}
            </div>
          </div>
        ))}
      </div>
      <div className={`rarity ${isLarge ? 'large' : 'small'}`}>
        <div className="trait">
          <div className="trait-title">RARITY RANK</div>
          <div className="trait-value" style={{ marginLeft: isLarge ? "8px" : "0px"}}>{rarityRank}</div>
        </div>
      </div>
    </div>
  );
};

Thumbnail.propTypes = {
  tokenID: PropTypes.number.isRequired,
  tokenName: PropTypes.string.isRequired,
  traits: PropTypes.array.isRequired,
  rarityRank: PropTypes.number.isRequired,
  thumbnailSize: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default Thumbnail;
